module.exports = __webpack_public_path__ + "static/media/10_avatar_female.2584c6e5.png";